import { marked, Renderer, Tokens } from 'marked';

const CHART_CODE_LANG = 'chart';
const ANCHOR_OPEN_TAG = '<a ';
const NEW_TAB_ANCHOR_OPEN_TAG = '<a target="_blank" rel="noopener noreferrer" ';

const renderLink = Renderer.prototype.link;

let configured = false;

export function setupAiChatMarkdown(): void {
	if (configured) {
		return;
	}
	configured = true;

	marked.use({
		renderer: {
			code({ lang }: { text: string; lang?: string }) {
				if (lang === CHART_CODE_LANG) {
					return '';
				}
				return false as any;
			},
			link(token: Tokens.Link) {
				return renderLink.call(this, token).replace(ANCHOR_OPEN_TAG, NEW_TAB_ANCHOR_OPEN_TAG);
			},
		},
	});
}
